import FaqAccordion from '@/components/faqAccordion/FaqAccordion';
import FaqFeedback from '@/components/faqFeedback/FaqFeedback';
import { RichText } from '@/components/richText/RichText';
import type { GlobalHelpCenterSettingsStoryblok, PageFaqStoryblok } from '@/types/component-types-sb';
import type { ISbStoryData } from '@storyblok/react/rsc';

import classes from './FaqPageContent.module.scss';

export type FaqPageContentProps = {
  blok: PageFaqStoryblok;
  storyId: number;
  storySlug: string;
  helpCenterSettings: GlobalHelpCenterSettingsStoryblok;
  faqHeadline: string;
  faqItems: ISbStoryData<PageFaqStoryblok>[];
  withAccordion?: boolean;
};

export const FaqPageContent: React.FC<FaqPageContentProps> = ({
  blok,
  storyId,
  storySlug,
  helpCenterSettings,
  faqHeadline,
  faqItems,
  withAccordion = true,
}) => {
  return (
    <div className={classes.content}>
      <div>
        <h3 className={classes.headline}>{blok.title}</h3>
        <RichText text={blok.text} />
        <FaqFeedback
          storyId={storyId}
          storySlug={storySlug}
          text={helpCenterSettings.faqFeedbackText}
          className={classes.faqFeedback}
        />
      </div>

      {withAccordion && (
        <FaqAccordion
          headline={faqHeadline}
          faqFeedbackText={helpCenterSettings.faqFeedbackText}
          withTags
          faqItems={faqItems}
          slug={storySlug}
          storyId={storyId}
        />
      )}
    </div>
  );
};

export default FaqPageContent;
